import * as React from 'react'
import { Videos } from '../../icons'
import { LinkComponent } from '../link-component'
import { Styled } from './styled'

export const ProductFrame = (props) => {
  const {
    name,
    Logo,
    url,
    color,
    watchDemoClick,
    onMouseEnter,
    onMouseLeave,
    additionalInfo,
    id,
    RouterLink
  } = props;
  return (
    <Styled.Frame
      color={color}
      id={id}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      withVideo={watchDemoClick}
    >
      <RouterLink to={url}>
        <Styled.ProductInfo color={color} withVideo={watchDemoClick}>
          <Styled.LogoWithName color={color}>
            <Logo />
            <Styled.ProductName>{name.toUpperCase()}</Styled.ProductName>
            {additionalInfo && <Styled.AdditionalInfo>{additionalInfo}</Styled.AdditionalInfo>}
          </Styled.LogoWithName>
          <Styled.Border />
        </Styled.ProductInfo>
      </RouterLink>
      {watchDemoClick &&
        <LinkComponent
          Icon={Videos}
          text={'Watch a demo'}
          size='m'
          fontSize='12'
          onClick={watchDemoClick}
        />
      }
    </Styled.Frame>
  )
}
